import { Alert, Link } from "@mm/components";
import { MAX_ALLOWED_MENU_BTNS } from "@mm/constants/widgets";
import MainMenuCRUDActions from "@mm/state/actions/MainMenuCRUDActions";
import {
    activeFacebookPagePlanInfoSelector,
    activeFacebookPageSelector
} from "@mm/state/selectors/facebookPageSelector";
import { mainMenuButtonsSelector } from "@mm/state/selectors/mainMenuSelectors";
import { activeChatbotIdSelector } from "@mm/state/selectors/viewSelectors";
import React from 'react';
import { connect, useSelector } from 'react-redux';
import { Col, Row } from 'reactstrap';
import { compose, lifecycle } from 'recompose';
import MenuButtonListEditor from '../widgets/MenuButtonListEditor/MenuButtonListEditor';
import '../widgets/MenuButtonListEditor/MenuButtonListEditor.pcss';
import './makeWidget.scss';

const MenuEditorWidgetBase = props => {
  const {
    buttons,
    onCreateButton,
    onUpdateButton,
    onDeleteButton,
  } = props;
  const title = 'Main Menu';
  const buttonProps = {
    buttons,
    onCreateButton,
    onUpdateButton,
    onDeleteButton,
    maxButtonCount: MAX_ALLOWED_MENU_BTNS,
  };

  return (
    <div className="widget-component">
      <div
        className="widget-component__outer-container"
      >
        <div className="widget-component__title-container">
          <div className="widget-component__title-item">{title}</div>
        </div>
        <div />
        <MenuButtonListEditor {...buttonProps} />
      </div>
    </div>
  )
};

const mapStateToProps = state => ({
  chatbotId: activeChatbotIdSelector(state),
  freeOrSpecialPricePlan: activeFacebookPagePlanInfoSelector(state).info.isFreeOrSpecialPlan,
  buttons: mainMenuButtonsSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
  onCreateButton: (chatbotId, menuItem) =>
    dispatch(MainMenuCRUDActions.create(chatbotId, menuItem)),
  getMenuItems: (chatbotId) =>
    dispatch(MainMenuCRUDActions.retrieveAll(chatbotId)),
  onDeleteButton: (chatbotId, menuItem) =>
    dispatch(MainMenuCRUDActions.delete(chatbotId, menuItem)),
  onUpdateButton: (chatbotId, menuItem) =>
    dispatch(MainMenuCRUDActions.update(chatbotId, menuItem)),
});

function componentDidMount() {
  const { getMenuItems, chatbotId } = this.props;
  getMenuItems(chatbotId);
}

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  lifecycle({ componentDidMount }),
);

const MenuEditorWidget = enhance(MenuEditorWidgetBase);

const MenuEditorPane = () => {
  const facebookPage = useSelector(activeFacebookPageSelector);
  const showEuLimitsWarning = !!facebookPage?.euLimitsAt;

  return (
    <div className="menu-editor__outer-container">
      <Row style={{ margin: '10px 0 15px 0' }}>
        <Col>
          {showEuLimitsWarning && (
            <Alert type="warning">
              This feature is no longer available on Messenger due to.{' '}
              <Link
                href="https://mobilemonkey.com/help/article/cg1qvuexfy-updated-messaging-policies-for-eu-pages-users"
                isBlank
              >
                EU policy changes.
              </Link>
            </Alert>
          )}
        </Col>
      </Row>
      <Row className="justify-content-center" style={{ margin: 0 }}>
        <Col xs="12" sm="10" md="7">
          <div className="menu-editor__widget-container">
            <MenuEditorWidget />
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default MenuEditorPane;
